
export const ONCALL = "ONCALL";
export const RTCPROCESS = "RTCPROCESS"
export const RTCFAILED = "RTCFAILED"
export const RTCENDED = "RTCENDED"
export const SET_WEBRTCSTATUS ="SET_WEBRTCSTATUS"
export const SET_SHOWCALLLOGPAGE ="SET_SHOWCALLLOGPAGE"
export const SET_AGENTSTATUS ="SET_AGENTSTATUS"

